/* eslint-disable class-methods-use-this */
// https://jira.sephora.com/browse/UA-1872
const SEPHORA_GRAPHQL_API_ENDPOINT = Sephora.configurationSettings.gqlAPIEndpoint;
class FetchMiddleware {
    async request(context, _next) {
        const options = {
            method: 'POST',
            headers: context.headers,
            body: JSON.stringify(context.body)
        };

        const response = await window.fetch(SEPHORA_GRAPHQL_API_ENDPOINT, options);

        // RetryMiddleware will check response.status and handle retries
        if (!response.ok) {
            return response;
        }

        const responseData = await response.json();

        return responseData;
    }
}

export default FetchMiddleware;
